import React from 'react';

const SvgGm = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="GM_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="GM_svg__b" fill="#fff">
        <use xlinkHref="#GM_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#GM_svg__a" />
      <path fill="#DF2237" mask="url(#GM_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#4B9334" mask="url(#GM_svg__b)" d="M0 13.333h28V20H0z" />
      <path fill="#FFF" mask="url(#GM_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path fill="#1526A7" mask="url(#GM_svg__b)" d="M0 8h28v4H0z" />
    </g>
  </svg>
);

export default SvgGm;
